/* eslint-disable no-unused-vars */
import React from 'react';
import MyAds from 'components/pages/MyAds';
import TopUp from 'components/pages/TopUp';
import Investment from 'components/pages/Investment';
import FQA from 'components/pages/FQA';
import MarketSetting from 'components/pages/MarketSetting';
import MarketingHome from 'components/pages/Marketing/MarketingHome';
import MarketingOffer from 'components/pages/Marketing/MarketingOffer';
import MarketingCalculator from 'components/pages/Marketing/MarketingCalculator';
import MarketingQuestions from 'components/pages/Marketing/MarketingQuestions';
import PlayGround from 'components/pages/PlayGround';
import AdSetting from 'components/pages/CreateAd/AdSetting';
import SelectOptionStep from 'components/pages/CreateAd/SelectOptionStep';
import ResourceSetting from 'components/pages/ResourceSetting';
import SignIn from 'components/pages/SignIn';
import { Switch, Route, Redirect } from 'react-router-dom';
import AppBar from '../AppBar';
import Styles from './index.module.css';

function Routes() {
  const renderWithAppBar = () => (
    <>
      <AppBar />
      <Route path="/MyAds" component={MyAds} />
      <Route path="/TopUp" component={TopUp} />
      <Route path="/INV" component={Investment} />
      <Route path="/FQA" component={FQA} />
      <Route path="/MarketSetting" component={MarketSetting} />
      <Route path="/PlayGround" component={PlayGround} />
      <Route path="/AdSetting" component={AdSetting} />
      <Route path="/SelectOptionStep" component={SelectOptionStep} />
      <Route path="/FbResourceSetting" component={ResourceSetting} />
      <Route path="/GoogleResourceSetting" component={ResourceSetting} />
    </>
  );

  return (
    <Switch>
      <Route
        exact
        path="/"
        render={() => (
          // <Redirect to="/Register" />
          <Redirect to="/Home" />
        )}
      />
      <Route path="/password-reset" component={SignIn} />
      <Route path="/Offer" component={MarketingOffer} />
      <Route path="/Home" component={MarketingHome} />
      <Route path="/Calculator" component={MarketingCalculator} />
      <Route path="/QA" component={MarketingQuestions} />
      <Route path="/Register" component={SignIn} />
      <div className={Styles.switchWapper}>
        <Switch>
          <Route exact path="/Register" component={SignIn} />
          <Route component={renderWithAppBar} />
        </Switch>
      </div>
    </Switch>
  );
}

export default Routes;
